import React from 'react'
import Navbar from '../components/navbar'
import Hero from '../components/hero'
import Footer from '../components/footer'
import Whatwedo from '../components/whatwedo'
const Home = () => {
  return (
    <>
    <Navbar/>
    <Hero/>
    <Whatwedo/>
    <Footer/>
    </>
  )
}

export default Home